// extracted by mini-css-extract-plugin
export var borderRadius = "_ep-4";
export var large = "_ep-3";
export var logoContainer = "_ep-0";
export var nameLogo = "_ep-2";
export var small = "_ep-1";